Alpine.data('alpine_item_list_share', () => ({
  email: '',
  emails: [],
  error: '',
  message: '',
  shareModalOpen: false,

  addAddress() {
      if(this.email === '') {
          return;
      }

      if(!this.validateEmail()) {
          this.error = "Please enter a valid email address.";
          return;
      }

      this.emails.push(this.email);
      this.email = '';
  },

  checkSubmit(e) {
    if(!this.email && !this.emails.length) {
      e.preventDefault();

      return false;
    }
  },

  recheckError() {
    if(!this.error) {
      return;
    }

    if(this.validateEmail()) {
      this.error = '';
    }
  },

  validateEmail() {
      return this.email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  },

  init() {
      this.$watch('shareModalOpen', value => {
          if(!value) {
            this.email = '';
            this.emails = [];
            this.error = '';
            this.message = '';
          }
      });
  },
}));
